import React from 'react'
import PropTypes from 'prop-types'
import { Alert } from 'reactstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import { Row, Col} from  'reactstrap'

function CustomAlert({primary, secondary, icon, className, toggle, isOpen}) {
  const getIcon = (icon) => {
    const iconMapper = {
      info: "info-circle",
    }

    return iconMapper[icon];
  }

  return (
    <Alert isOpen={isOpen} toggle={toggle} color="danger" className="d-flex mx-auto rounded" closeClassName="close text-danger">
      <Row className="w-100">
          <Col xs={12} className="d-flex">
              <div className="align-self-center">
                <FontAwesomeIcon icon={getIcon(icon)} className={`text-danger mr-2`} />
                <small className="mb-0"><b>{primary}</b> - {secondary}</small>
              </div>
          </Col>
      </Row>
    </Alert>
  )
}

CustomAlert.propTypes = {

}

export default CustomAlert

